import React, { FC } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import {
  AssistMigrationDistributionPreview,
  AssistMigrationStoreSection,
} from 'types/assist/assistMigration';
import { StoreDistributionEditor } from './StoreDistributionEditor';

interface StoreSectionEditorProps {
  distribution: AssistMigrationDistributionPreview;
  section: AssistMigrationStoreSection;
  onUpdateStore: (
    storeId: number,
    patch: Partial<AssistMigrationDistributionPreview['stores'][number]>,
  ) => void;
}

export const StoreSectionEditor: FC<StoreSectionEditorProps> = ({
  distribution,
  section,
  onUpdateStore,
}) => (
  <>
    {distribution.stores.map((store) => (
      <Accordion
        key={store.storeId}
        disableGutters
        sx={{
          border: '1px solid',
          borderColor: 'primary.light',
          borderRadius: 1,
          mb: 1,
          boxShadow: 'none',
          '&:before': { display: 'none' },
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          sx={{
            bgcolor: 'primary.main',
            color: 'primary.contrastText',
            borderRadius: '4px 4px 0 0',
            minHeight: 36,
            '& .MuiAccordionSummary-content': { margin: '6px 0' },
            '& .MuiSvgIcon-root': { color: 'primary.contrastText' },
          }}
        >
          <Typography variant="caption" style={{ fontWeight: 700 }}>
            {store.storeName}
          </Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ p: 1 }}>
          <StoreDistributionEditor
            section={section}
            store={store}
            globalFaqs={distribution.global.faqs}
            onChange={(patch) => onUpdateStore(store.storeId, patch)}
          />
        </AccordionDetails>
      </Accordion>
    ))}
  </>
);
